<template>
  <div
    class="form__input"
    :class="{'form__input--error': !!error }"
  >
    <input
      :id="id"
      ref="input"
      v-model="inputValue"
      :type="type"
      :value="value"
      :required="required"
      :disabled="disabled"
      :class="{
        'input': true,
        'input__error': !!error,
        'has-input': value !== '' || type.includes('date')
      }"
      :name="name"
      :max="max"
      :min="min"
      :maxlength="maxlength"
      :autocomplete="autocomplete ? '' : 'off'"
      @change="changeValue"
      @blur="$emit('blur')"
    >
    <label
      v-if="label"
      :for="id"
      class="form__label"
    >
      {{ label }}
    </label>
    <p
      v-show="error"
      class="form__error"
    >
      {{ error }}
    </p>
  </div>
</template>

<script>
export default {
  $_veeValidate: {
    name() {
      return this.label;
    },
    value() {
      return this.value;
    },
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Form Label',
    },
    name: {
      type: String,
      default: 'form-name',
    },
    id: {
      type: String,
      default: 'form-id',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
      required: false,
    },
    min: {
      type: String,
      default: '',
      required: false,
    },
    max: {
      type: String,
      default: '',
      required: false,
    },
    maxlength: {
      type: String,
      default: '',
      required: false,
    },
    type: {
      type: String,
      default: 'text',
      validator: val => ['url', 'number', 'text', 'password', 'email', 'search', 'tel', 'date', 'datetime-local'].indexOf(val) !== -1,
    },
    autocomplete: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    inputValue: {
      get() {
        if (this.type === 'tel') {
          const returnVal = this.handlePhoneNumber(this.value);
          if (this.value !== returnVal) {
            this.$emit('input', returnVal);
          }
          return returnVal;
        }
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    handlePhoneNumber(e) {
      if (e) {
        const x = e.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ''}`;
      }
      return '';
    },
    changeValue(e) {
      this.$emit('change', 'input', e.target.value);
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
